// console.log("Lazy Loading Init");

// Fix: Polaris renders itself as <dialog id="polaris-consent-widgets"> with
// inline z-index:999999 and the theme's CSS makes all dialogs position:fixed
// covering the full viewport. This makes it non-modal (so it stops blocking
// the page) and collapses it to only its natural height at the bottom.
(function () {
  function fixPolarisDialog() {
    var dialog = document.querySelector('dialog#polaris-consent-widgets');
    if (!dialog) return;

    // OLD CODE: If opened as a modal (top layer), convert to non-modal
    if (typeof dialog.matches === 'function' && dialog.matches(':modal')) {
      try {
        dialog.close(); 
        dialog.show();
      } catch (e) {}
    }

    // Force the dialog to only occupy its natural height at the bottom
    dialog.style.setProperty('position', 'fixed', 'important');
    dialog.style.setProperty('top', 'auto', 'important');
    dialog.style.setProperty('bottom', '0', 'important');
    dialog.style.setProperty('left', '0', 'important');
    dialog.style.setProperty('right', '0', 'important');
    dialog.style.setProperty('height', 'auto', 'important');
    dialog.style.setProperty('max-height', 'none', 'important');
    dialog.style.setProperty('width', '100%', 'important');
    dialog.style.setProperty('pointer-events', 'auto', 'important');
  }

  // Watch for Polaris injecting its widget into the DOM
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (document.querySelector('dialog#polaris-consent-widgets')) {
        fixPolarisDialog();
        break;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'style'] });

  // Also try immediately in case Polaris already ran
  fixPolarisDialog();
})();

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.lazy-image').forEach(img => {
        img.classList.remove('lazy-image');
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }
    });

    document.querySelectorAll('.lazy-image--backfill').forEach(img => {
        img.classList.remove('lazy-image--backfill');
        if (img.dataset.src) {
            img.src = img.dataset.src;
        }
    });
});

